import type { FeedbackListItemWithBlock } from '@/types/feedback';
import { buildObjQuery } from '@/utils/util';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { defaultAxios } from '..';

const homeService = {
  async fetchFeedbackChanged(
    params: HomeQueryParams,
  ): Promise<HomeFeedbackChanged> {
    try {
      const query = buildObjQuery(params);
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.get(
        `/workspaces/${wa}/home/changed${query}`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async fetchFeedbackDistribution(
    params: Omit<HomeQueryParams, 'view_type'>,
  ): Promise<HomeFeedbackDistribution> {
    try {
      const query = buildObjQuery(params);
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.get(
        `/workspaces/${wa}/home/distribution${query}`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async fetchFeedbackTrend(
    params: HomeQueryParams,
  ): Promise<HomeFeedbackTrend> {
    try {
      const query = buildObjQuery(params);
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.get(
        `/workspaces/${wa}/home/trend${query}`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async fetchHomeTopics(query: string): Promise<HomeTopicItem[]> {
    try {
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.get(
        `/workspaces/${wa}/home/topics${query}`,
      );
      return res.data.topics || [];
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async fetchMostNegativeFeedbacks(): Promise<FeedbackListItemWithBlock[]> {
    try {
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.get(
        `/workspaces/${wa}/home/negative_feedbacks`,
      );
      return res.data || [];
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};

export default homeService;
